export const loginPage = {
  cardWidth: 520,
  cardMaxWidth: '100%',
  cardBorderRadius: 3,
  cardPaddingX: { xs: 3, sm: 5 },
  cardPaddingY: { xs: 4, sm: 5 },
  cardShadow: '0 12px 40px rgba(15, 28, 46, 0.08)',
  cardBorder: '1px solid rgba(217, 226, 238, 0.85)',
  backgroundColor: '#f5f7fa',
  decorationCircleSize: { xs: 280, sm: 420 },
  decorationCircleBorder: '1px dashed rgba(180, 190, 205, 0.45)',
  azureButtonBg: '#0f1c2e',
  azureButtonHoverBg: '#1a2d47',
  azureButtonFocusRing: '0 0 0 3px rgba(15, 28, 46, 0.25)',
  footerLinkColor: '#5c6b7a',
  footerCopyrightColor: '#8a97a5',
  headingColor: '#1a1c2e',
  headingFontSize: { xs: '1.625rem', sm: '1.75rem' },
  headingFontWeight: 700,
  subtitleFontSize: { xs: '0.9375rem', sm: '1rem' },
  subtitleColor: '#6c757d',
} as const;
